/*const DAY_WIDTH = 24; // px per day

export function daysBetween(a: Date, b: Date) {
  return Math.floor(
    (b.getTime() - a.getTime()) / (1000 * 60 * 60 * 24)
  );
}

export function leftPx(date: Date, timelineStart: Date) {
  return daysBetween(timelineStart, date) * DAY_WIDTH;
}

export function widthPx(start: Date, end: Date) {
  return Math.max(
    DAY_WIDTH,
    daysBetween(start, end) * DAY_WIDTH
  );
}*/
const DAY_MS = 24 * 60 * 60 * 1000;

/*
export function daysBetween(a: Date, b: Date) {
  return Math.round((b.getTime() - a.getTime()) / DAY_MS);
}*/
export function daysBetween(a: Date, b: Date) {
  const diff = (b.getTime() - a.getTime()) / DAY_MS;
  return Math.max(1, Math.ceil(diff));
}


export function leftPx(
  date: Date,
  timelineStart: Date,
  pxPerDay: number
) {
  return daysBetween(timelineStart, date) * pxPerDay;
}

/*
export function widthPx(
  start: Date,
  end: Date,
  pxPerDay: number
) {
  return Math.max(1, daysBetween(start, end) * pxPerDay);
}
*/
/*
export function widthPx(
  start: Date,
  end: Date,
  pxPerDay: number
) {
  const days = Math.max(1, daysBetween(start, end) + 1);
  return days * pxPerDay;
}
*/
export function widthPx(
  start: Date,
  end: Date,
  pxPerDay: number
) {
  const days = Math.max(1, daysBetween(start, end) + 1);
  //return Math.max(days * pxPerDay, 8);
  return Math.max(days * pxPerDay, pxPerDay);

}



